module.exports = __webpack_public_path__ + "assets/img/tjj.75f29401.png";